// CaptchaBox.jsx
import React, { useState, useEffect, useImperativeHandle, forwardRef } from 'react';

const CaptchaBox = forwardRef((props, ref) => {
  const [captchaImage, setCaptchaImage] = useState('');
  const [userInput, setUserInput] = useState('');
  const [correctAnswer, setCorrectAnswer] = useState(null);

const generateCaptcha = () => {
  const num1 = Math.floor(Math.random() * 10); // 0 to 9
  const num2 = Math.floor(Math.random() * 10); // 0 to 9

  const question = `${num1} + ${num2}`;
  const answer = num1 + num2;

  setCorrectAnswer(answer);
  renderCaptchaAsImage(question);
};


  const renderCaptchaAsImage = (text) => {
    const canvas = document.createElement('canvas');
    canvas.width = 150;
    canvas.height = 40;
    const ctx = canvas.getContext('2d');
    ctx.font = '28px Arial';
    ctx.fillStyle = '#000';
    ctx.fillText(text, 10, 30);
    setCaptchaImage(canvas.toDataURL());
  };

  // ✅ Expose validateCaptcha to parent using ref
  useImperativeHandle(ref, () => ({
    validateCaptcha: () => Number(userInput) === correctAnswer,
  }));

  useEffect(() => {
    generateCaptcha();
  }, []);

  return (
    <div className="align-items-md-center d-flex margin-bottom-5px">
      <div className="captchabox">
        <div className="captchabox-6">
          <img src={captchaImage} alt="captcha" />
        </div>
        <div className="captchabox-6 captcha-ref-box">
          <input
            className="field p-relative ps-2"
            type="number"
            name="solution"
            id="solution"
            placeholder="Solve captcha"
            value={userInput}
            onChange={(e) => setUserInput(e.target.value)}
          />
          <i
            className="fa fa-refresh ml-1 text-success"
            style={{ cursor: 'pointer' }}
            onClick={generateCaptcha}
          />
        </div>
      </div>
    </div>
  );
});

export default CaptchaBox;
